import { commandToolbarLabel } from '../strings.locstring.json';
import loc from 'owa-localize';
import { ComposeCommandingBar } from 'owa-mail-compose-view';
import { MailCommandingBar } from 'owa-mail-commandbar';
import { SecondaryReadingPaneTabCommandingBar } from 'owa-mail-reading-pane-view';
import { listViewStore } from 'owa-mail-list-store';
import { TabViewState, TabType } from 'owa-tab-store';
import { getFullComposeShowingInTabContentArea } from 'owa-mail-compose-actions';
import { globalStyles } from 'owa-global-styles';
import * as React from 'react';
import { observer } from 'mobx-react';
import {
    isReadingPanePositionOff,
    isReadingPanePositionRight,
    getListViewDimensions,
} from 'owa-mail-layout';

const styles = require('./MailModule.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MailCommandBarViewProps {
    activeTab: TabViewState;
    isDumpsterOrDumpsterSearchTable: boolean;
}

@observer
export default class MailCommandBarView extends React.Component<MailCommandBarViewProps, any> {
    render() {
        return (
            <div
                tabIndex={-1}
                className={classNames(styles.commandBar, globalStyles.addFocusOutline)}
                role={'region'}
                aria-label={loc(commandToolbarLabel)}>
                {this.renderCommandBar()}
            </div>
        );
    }

    private renderCommandBar() {
        const { activeTab, isDumpsterOrDumpsterSearchTable } = this.props;

        const activeFullComposeViewState = getFullComposeShowingInTabContentArea();
        const isShowingFullSecondaryReadingPane =
            activeTab &&
            activeTab.type == TabType.SecondaryReadingPane &&
            isReadingPanePositionOff();

        let commandBarStyle;
        if (activeFullComposeViewState && isReadingPanePositionRight()) {
            commandBarStyle = { paddingLeft: getListViewDimensions().listViewWidth };
        }

        if (
            !isDumpsterOrDumpsterSearchTable &&
            /* Should never show compose command bar if in dumpster */ activeFullComposeViewState
        ) {
            return (
                <ComposeCommandingBar
                    composeViewState={activeFullComposeViewState}
                    styles={{ root: commandBarStyle }}
                />
            );
        }

        if (isShowingFullSecondaryReadingPane) {
            return <SecondaryReadingPaneTabCommandingBar tab={activeTab} />;
        }

        return <MailCommandingBar tableViewId={listViewStore.selectedTableViewId} />;
    }
}
